module.exports = __webpack_public_path__ + "img/icon_kehu_06.5cd8517f.png";